class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    event.stopPropagation();

    const container = this.closest('.gf-block-content, .facets__display-vertical');
    const parentWrap = container ? container.querySelector('.facets-wrap') : null;
    if (!parentWrap) return;

    parentWrap.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));

    const showMoreLabel = this.querySelector('.label-show-more');
    const showLessLabel = this.querySelector('.label-show-less');
    if (showMoreLabel) showMoreLabel.classList.toggle('hidden');
    if (showLessLabel) showLessLabel.classList.toggle('hidden');
  }
}

if (!customElements.get('show-more-button')) {
  customElements.define('show-more-button', ShowMoreButton);
}
